import { render, staticRenderFns } from "./OracleInfo.vue?vue&type=template&id=1dd290e5&scoped=true&"
import script from "./OracleInfo.vue?vue&type=script&lang=js&"
export * from "./OracleInfo.vue?vue&type=script&lang=js&"
import style0 from "./OracleInfo.vue?vue&type=style&index=0&id=1dd290e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd290e5",
  null
  
)

component.options.__file = "OracleInfo.vue"
export default component.exports